module.exports = __webpack_public_path__ + "img/img-3-10mobile.b13a11c2.png";